module.exports = __webpack_public_path__ + "08ec6f6e93e5e52762ff63c3cf734184.png";